function useGetNewSessionStorage() {
    const newSession = sessionStorage.getItem("newSession");
    if (newSession) {
        return JSON.parse(newSession);
    }

    return null;
}

export default useGetNewSessionStorage;